import React from 'react';
import { Stack, Typography, CardMedia } from '@mui/material';
import { ContainedButton } from '../../commons/hoc';
import { useRouter } from 'next/router';
import styles from './MiniProductCard.module.scss';

const miniProdCardClassMap = {
  rel: styles.rel,
  zen: styles.zen,
  gof: styles.gof,
  zfa: styles.zfa,
  tnk: styles.tnk,
};

export default function MiniProductCard({
  productImg,
  category,
  productName,
  link,
  gradientType,
  isTabletOrMobile,
  btnText = 'Shop Now',
  btnType = 'dark',
  onButtonClick,
  sx = {},
}) {
  const router = useRouter();

  const handleButtonClick = () => {
    if (onButtonClick) {
      onButtonClick();
      return;
    }

    if (router.pathname === '/') {
      router.push(link);
    } else {
      router.push(
        {
          pathname: link,
          hash: 'buy',
        },
        undefined,
        { scroll: false }
      );
    }
  };

  return (
    <Stack
      className={`${styles.miniProdCardContainer}`}
      style={sx}
      sx={{
        my: { lg: 5, md: 2, sm: 5, xs: 5 },
        ml: 1,
        width: isTabletOrMobile ? 353 : { md: '95%', sm: '94%', xs: '94%' },
        maxWidth: { lg: 600, md: '100%', sm: '94%', xs: '94%' },
      }}
    >
      <Stack
        className={`${styles.miniProdCardContent} ${
          miniProdCardClassMap[gradientType] || ''
        }`}
        sx={{
          py: { lg: 2, md: 1.5, sm: 1.5, xs: 1.5 },
          px: { lg: 3, md: 2, sm: 2, xs: 1 },
        }}
      >
        <div className={styles.miniProdCardProduct}>
          <CardMedia
            component="img"
            className={styles.miniCartImg}
            image={productImg}
            alt={productName || ''}
          />
          <Stack
            display="flex"
            direction="column"
            alignItems="left"
            justifyContent="center"
            sx={{
              pl: { lg: 3, sm: 1, xs: 1 },
              textAlign: 'left',
              textWrap: 'pretty',
            }}
          >
            <Typography variant="p2" color="primary.black">
              {category}
            </Typography>
            <Typography
              variant="h4"
              color="primary.main"
              sx={{
                whiteSpace: { lg: 'nowrap', md: 'normal', xs: 'normal' },
                textWrap: 'pretty',
              }}
            >
              {productName}
            </Typography>
          </Stack>
        </div>
        <div className={styles.miniProdCardBtnContainer}>
          <ContainedButton
            style={{ height: '35px' }}
            onClick={handleButtonClick}
            btnType={btnType}
          >
            {btnText}
          </ContainedButton>
        </div>
      </Stack>
    </Stack>
  );
}
